var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgXml = function SvgXml(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.06 208.45",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".xml_svg__c-xml{fill:#f29c1f}.xml_svg__d-xml{fill:#fff}"))), /*#__PURE__*/React.createElement("path", {
    d: "M119.975 0H11.946C8.938 0 6.5 2.438 6.5 7.169v197.558c0 1.284 2.438 3.722 5.446 3.722h149.168c3.008 0 5.446-2.438 5.446-3.722V48.308c0-2.591-.346-3.425-.957-4.039L122.29.957A3.3 3.3 0 0 0 119.975 0",
    style: {
      fill: "#f6f7fa"
    },
    transform: "translate(-6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5.151v44.106h44.106Z",
    style: {
      fill: "#dee2ed"
    },
    transform: "translate(77.892 .411)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.614 208.449H5.446A5.446 5.446 0 0 1 0 203.004V145.17h160.06v57.834a5.446 5.446 0 0 1-5.446 5.445",
    className: "xml_svg__c-xml"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m47.94 179.062 9.518 18.221h-7.073l-5.956-14.149h-.51l-6.413 14.149h-7.073l9.518-18.221-10.128-19.289h6.972l6.616 15.269h.51l7.177-15.269h6.972ZM94.907 159.777h6.209v37.506h-6.209v-25.8l-8.4 20.864H81.12l-8.45-20.864v25.8h-6.208v-37.506h6.209l11.145 25.65ZM116.739 159.777v32.876h17.257v4.63h-23.462v-37.506Z",
    className: "xml_svg__d-xml"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.501 89.335a3.722 3.722 0 0 1-2.632-6.354l22.334-22.334a3.722 3.722 0 1 1 5.263 5.263L36.133 88.245a3.7 3.7 0 0 1-2.632 1.09",
    className: "xml_svg__c-xml"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.835 111.669a3.7 3.7 0 0 1-2.632-1.091L30.869 88.245a3.722 3.722 0 0 1 5.263-5.263l22.335 22.333a3.722 3.722 0 0 1-2.632 6.354M100.503 111.669a3.722 3.722 0 0 1-2.632-6.354l22.334-22.334a3.722 3.722 0 0 1 5.263 5.263l-22.333 22.335a3.7 3.7 0 0 1-2.632 1.09",
    className: "xml_svg__c-xml"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.837 89.335a3.7 3.7 0 0 1-2.632-1.091L97.871 65.911a3.722 3.722 0 0 1 5.263-5.263l22.335 22.333a3.722 3.722 0 0 1-2.632 6.354M67.001 119.114a3.73 3.73 0 0 1-3.51-4.966l22.334-63.279a3.723 3.723 0 0 1 7.02 2.479l-22.333 63.279a3.72 3.72 0 0 1-3.511 2.487",
    className: "xml_svg__c-xml"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgXml);
export default ForwardRef;